import { gql } from '@apollo/client';
import { QA_RESULT_FRAGMENT } from './qa-result-graphql';
import { GAME_FILE_FRAGMENT } from './game-file-graphql';

export const BUILDS_FRAGMENT = gql`
  fragment GameBuildFragment on GameBuild {
    id
    gameId
    createdAt
    status

    loaderType
    loaderConfigJson
    gameframeConfigJson
    files {
      ...GameFileragment
    }
    apsConfig {
      progressType
    }
    unityConfig {
      saveFileNames
    }
    totalFileSize
    s3Location

    fullscreen
    iosFriendly
    iosAppFriendly
    androidFriendly
    androidAppFriendly
    isEligibleForMobileHomepage
    chromebookFriendly
    safariFriendly
    hasIap
    mobileOrientation

    allowEmbed
    sandbox

    qaResult {
      ...QAResultFragment
    }
    adminQaResult {
      ...QAResultFragment
    }
    updateNotes
  }
  ${QA_RESULT_FRAGMENT}
  ${GAME_FILE_FRAGMENT}
`;
